import { render, staticRenderFns } from "./postCounters.vue?vue&type=template&id=b05d3584&lang=pug&"
import script from "./postCounters.vue?vue&type=script&lang=js&"
export * from "./postCounters.vue?vue&type=script&lang=js&"
import style0 from "./postCounters.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postCounters.vue"
export default component.exports